import { render, staticRenderFns } from "./planning-template.vue?vue&type=template&id=879ac020&"
import script from "./planning-template.vue?vue&type=script&lang=js&"
export * from "./planning-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports